import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

/**
 * Shimmer loading component
 */
@Component({
  selector: 'caixa-webcomponent-shimmer',
  standalone: true,
  templateUrl: './shimmer.component.html',
  styleUrls: ['./shimmer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShimmerComponent {
  /**
   * Width of the shimmer element
   */
  @Input()
  public width = '100%';

  /**
   * Height of the shimmer element
   */
  @Input()
  public height = '20px';

  /**
   * Border radius of the shimmer element
   */
  @Input()
  public borderRadius = '4px';

  /**
   * Margin bottom of the shimmer element
   */
  @Input()
  public marginBottom = '0px';

  /**
   * Number of shimmer lines to display
   */
  @Input()
  public lines = 1;

  /**
   * Get array of lines for ngFor
   */
  public get linesArray(): number[] {
    return Array(this.lines).fill(0).map((_, i) => i);
  }
}
